module.exports = __webpack_public_path__ + "assets/media/lunch.161f17fb.mp3";